<template>
  <v-container fluid class="purchaseorder-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Purchase Order</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">New Purchase Order</p>
                        <v-select
                          class="mb-4"
                          :items=purchaseordertype
                          v-model="new_purchaseorder.purchaseordertype"
                          v-bind:error="errorindex == 0"
                          v-on:change="clearFields(); clearTransactions()"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the order type">
                        </v-select>
                        <v-menu
                          ref="new_purchaseorderdate"
                          v-model="new_purchaseorderdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_purchaseorder.purchaseorderdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_purchaseorder.purchaseorderdate"
                              label="Order Date"
                              v-bind="attrs"
                              v-bind:value="new_purchaseorder.purchaseorderdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the purchase order date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_purchaseorder.purchaseorderdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="new_purchaseorderdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.new_purchaseorderdate.save(new_purchaseorder.purchaseorderdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="vendors.filter(vendor=>vendor.vendortype=='Supplier').map(x => {return {text: x.vendorcode, value: x._id};})"
                          v-model="new_purchaseorder.vendorid"
                          v-on:change="selectVendor"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Supplier"
                          persistent-hint
                          single-line hint="Please choose the supplier">
                        </v-select>      
                        <v-textarea
                          v-model="new_purchaseorder.purchaseorderaddress"
                          v-bind:error="errorindex == 3"
                          outlined
                          rows=2
                          label="Address"
                          hint="please enter the vendor address"
                        ></v-textarea>
                        <v-text-field
                          class="mb-4"
                          v-model="new_purchaseorder.purchaseorderphone"
                          v-bind:error="errorindex == 4"
                          outlined
                          dense
                          placeholder="Phone"
                          persistent-hint
                          single-line hint="Enter the phone">
                        </v-text-field>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                          v-model="new_purchaseorder.locationid"
                          v-bind:error="errorindex == 5"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-select
                          class="mb-4"
                          :items="pricelists.filter(list=>list.pricelisttype=='Purchasing').map(x => {return {text: x.pricelistname, value: x._id};})"
                          v-model="new_purchaseorder.pricelistid"
                          v-bind:error="errorindex == 6"
                          outlined
                          dense
                          placeholder="Price List"
                          persistent-hint
                          single-line hint="Please choose the pricelist">
                        </v-select>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <p class="text-h5">&nbsp;</p>
                        <v-select
                          class="mb-4"
                          :items=purchaseorderpayterms
                          v-model="new_purchaseorder.purchaseorderpayterms"
                          v-bind:error="errorindex == 7"
                          outlined
                          dense
                          placeholder="Pay Terms"
                          persistent-hint
                          single-line hint="Please choose the pay terms">
                        </v-select>
                        <v-textarea
                          v-model="new_purchaseorder.purchaseordernote"
                          v-bind:error="errorindex == 8"
                          outlined
                          rows=3
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/purchaseorder/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-row justify="center">
                    <v-col lg="12" md="12" sm="12"><p class="text-h5">Items</p></v-col>
                    <v-col cols="12" sm="12" md="2" lg="2">
                      <v-select
                        class="mb-4"
                        :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id};})"
                        v-model="brandid"
                        v-bind:error="errorindex == 2"
                        v-on:change="populateItems"
                        outlined
                        dense
                        placeholder="Brand"
                        persistent-hint
                        single-line hint="Brand">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2">
                      <v-select
                        class="mb-4"
                        :items=branditems
                        v-model="add_transaction.itemid"
                        v-bind:error="errorindex == 11"
                        v-on:change="populatePriceField"
                        outlined
                        dense
                        placeholder="Item"
                        persistent-hint
                        single-line hint="Item">
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1">
                      <v-text-field
                        v-model="add_transaction.itemquantity"
                        v-bind:error="errorindex == 12"
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Qty"
                        persistent-hint
                        type="number"
                        v-on:input="calculateAmount"
                        oninput="if(this.value < 1) this.value = 1;"
                        single-line hint="Quantity">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1">
                      <v-text-field
                        v-model="add_transaction.itemcost"
                        v-on:input="calculateAmount"
                        type="number"
                        v-bind:error="errorindex == 12"
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Cost"
                        persistent-hint
                        single-line hint="Cost">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="2" lg="2">
                      <v-text-field
                        readonly
                        v-model="add_transaction.itemamount"
                        class="mb-4"
                        outlined
                        dense
                        placeholder="Amt"
                        persistent-hint
                        single-line hint="Amount">
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12" md="1" lg="1">
                      <v-btn
                        class="button-shadow"
                        color="success"
                        @click="insertTransaction()">
                        Add
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                      <v-col cols="12" sm="12" md="12" lg="12">
                        <v-data-table
                            :headers="transHeaders"
                            :items="transactions"
                            :items-per-page="100"
                            class="elevation-0"
                          >
                            <template v-slot:item.itemimage="{ item }"> 
                              <v-img
                                v-bind:lazy-src="item.itemimage"
                                min-width=50
                                max-width=100
                                v-bind:src="item.itemimage"
                              ></v-img>
                            </template>
                            <template v-slot:item.actions="{ item }">
                              <v-btn icon color="primary" @click="editTransactionLoad(item)">
                                <v-icon>mdi-pencil-outline</v-icon>
                              </v-btn>
                              <v-btn icon color="primary" @click="deleteTransaction(item)">
                                <v-icon>mdi-close</v-icon>
                              </v-btn>
                            </template>
                          </v-data-table>
                      </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                        <div class="d-flex justify-center">
                          <v-btn
                            outlined
                            color="primary"
                            @click="step = 1"
                          >
                            Back
                          </v-btn>
                          <v-spacer></v-spacer>
                          <v-btn
                            v-if="1==0"
                            class="button-shadow"
                            color="primary"
                            @click="step = 3">
                            Next
                          </v-btn>
                          <v-btn
                            v-else
                            :loading="isReceiving"
                            class="button-shadow"
                            color="primary"
                            @click="insertPurchaseOrder()">
                            Save
                          </v-btn>
                        </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
    <div>
      <v-dialog
        v-model="isEditTransaction"
        persistent
        width="800px"
        max-width="800px"
      >
        <v-card>
          <v-card-title>
            <span class="text-h5">Edit Item</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items="brands.filter(brand=>brand.brandtype=='Brand').map(x => {return {text: x.brandname, value: x._id};})"
                    v-model="brandid"
                    v-bind:error="errorindex == 21"
                    v-on:change="populateItems"
                    outlined
                    dense
                    placeholder="Brand"
                    persistent-hint
                    single-line hint="Brand">
                  </v-select>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    class="mb-4"
                    :items=branditems
                    v-model="edit_transaction.itemid"
                    v-bind:error="errorindex == 22"
                    v-on:change="populatePriceFieldEdit"
                    outlined
                    dense
                    placeholder="Item"
                    persistent-hint
                    single-line hint="Item">
                  </v-select>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.itemquantity"
                    v-bind:error="errorindex == 23"
                    v-on:input="calculateAmountEdit"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Qty"
                    persistent-hint
                    type="number"
                    oninput="if(this.value < 1) this.value = 1;"
                    single-line hint="Quantity">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    v-model="edit_transaction.itemcost"
                    v-bind:error="errorindex == 24"
                    v-on:input="calculateAmountEdit"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Cost"
                    type="number"
                    persistent-hint
                    single-line hint="Cost">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field
                    readonly
                    v-model="edit_transaction.itemamount"
                    class="mb-4"
                    outlined
                    dense
                    placeholder="Amt"
                    persistent-hint
                    single-line hint="Amount">
                  </v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="blue darken-1"
              text
              @click="isEditTransaction=false; edit_transaction={};"
            >
              Close
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="editTransaction"
            >
              Save
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      transHeaders: [
        { text: 'Image', value: 'itemimage', width: '10%' },
        { text: 'Name', value: 'itemname' },
        { text: 'Qty', value: 'itemquantity', width: '5%'},
        { text: '', value: 'unit', width: '5%' },
        { text: 'Prc', value: 'itemcost', width: '10%'},
        { text: 'Amount', value: 'itemamount', width: '10%'},
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      transactions: [],
      purchaseordertype: ['Purchase Order', 'Purchase Invoice'],
      purchaseorderpayterms: ['Due on Receipt', 'Credit 15 Days', 'Credit 30 Days'],
      branditems: [],

      new_purchaseorder: {},
      add_transaction: {},
      edit_transaction: {},

      step: 1,
      brandid: undefined,
      new_purchaseorderdate: false,
      error: undefined,
      errortags: false,
      errorindex: undefined,
      isAddTransaction: false,
      isEditTransaction: false,
    }
  },
  computed: {
    ...mapState('PurchaseOrder', ['isReceiving']),
    ...mapState('Brand', ['brands']),
    ...mapState('Item', ['items']),
    ...mapState('Location', ['locations']),
    ...mapState('Price', ['prices']),
    ...mapState('PriceList', ['pricelists']),
    ...mapState('Vendor', ['vendors']),
  },
  methods: {
    ...mapActions('PurchaseOrder', ['getPurchaseOrders', 'insertPurchaseOrderRequest']),
    ...mapActions('Brand', ['getBrandsRequest']),
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('Price', ['getPricesRequest']),
    ...mapActions('PriceList', ['getPriceListsRequest']),
    ...mapActions('Vendor', ['getVendorsRequest']),
    checkError(){
      if(!this.new_purchaseorder.purchaseordertype){
        this.errortag = true;
        this.errorindex = 0;
        return false;
      }
      if(!this.new_purchaseorder.purchaseorderdate){
        this.errortag = true;
        this.errorindex = 1;
        return false;
      }
      if(!this.new_purchaseorder.vendorid){
        this.errortag = true;
        this.errorindex = 2;
        return false;
      }
      if(!this.new_purchaseorder.locationid){
        this.errortag = true;
        this.errorindex = 5;
        return false;
      }
      if(!this.new_purchaseorder.pricelistid){
        this.errortag = true;
        this.errorindex = 6;
        return false;
      }
      if(!this.new_purchaseorder.purchaseorderpayterms){
        this.errortag = true;
        this.errorindex = 7;
        return false;
      }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    checkError2(){
      if(!this.add_transaction.itemid){
        this.errortag = true;
        this.errorindex = 11;
        return false;
      }
      if(!this.add_transaction.itemquantity){
        this.errortag = true;
        this.errorindex = 12;
        return false;
      }
      if(!this.add_transaction.itemcost){
        this.errortag = true;
        this.errorindex = 13;
        return false;
      }
      this.errorindex = -1;
      return true;
    },
    calculateAmount(){
      let amount = this.add_transaction.itemquantity * this.add_transaction.itemcost;
      let new_amount = {itemamount: amount};
      this.add_transaction = Object.assign({}, this.add_transaction, new_amount);
    },
    calculateAmountEdit(){
      let amount = this.edit_transaction.itemquantity * this.edit_transaction.itemcost;
      let new_amount = {itemamount: amount};
      this.edit_transaction = Object.assign({}, this.edit_transaction, new_amount);
    },
    calculateTotal(){
      this.new_purchaseorder.purchaseordersubtotal = this.transactions.reduce((a, b) => a + parseFloat(b.itemamount), 0);
      this.new_purchaseorder.purchaseordertotal = this.new_purchaseorder.purchaseordersubtotal;
    },
    clearFields(){
      this.add_transaction = Object.assign({});
    },
    clearTransactions(){
      this.transactions = [];
      this.new_purchaseorder.purchaseordersubtotal = 0;
      this.new_purchaseorder.purchaseordertotal = 0;
    },
    deleteTransaction(item){
      let index;
      index = this.findTransactionIndexByTransId(item.id);
      if(index!=-1) this.transactions.splice(index,1);
      this.calculateTotal();
    },
    editTransactionLoad(item){
      this.isEditTransaction = true;
      this.edit_transaction = Object.assign({}, item);
    },
    editTransaction(){
      let index = this.transactions.findIndex((trans) => trans.itemid == this.add_transaction.itemid);
      this.transactions.splice(index, 1, this.edit_transaction);
      this.isEditTransaction = false;
      this.calculateTotal();
      this.clearFields();
    },
    findTransactionIndexByTransId(id){
      let index;
      if(this.transactions.find(tran=>tran.id==id)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].id==id){break;}
      }
      return index;
    },
    findTransactionIndexByItemid(itemid){
      let index;
      if(this.transactions.find(tran=>tran.itemid==itemid)==null) {return -1}
      for(index=0; index<this.transactions.length; index++){
        if(this.transactions[index].itemid==itemid){break;}
      }
      return index;
    },
    findPriceByQuantity(pricelistid, itemid, quantity){
      let item = this.items.find(item=>item._id==itemid);
      let price = item.prices.find(price=>price.pricelistid==pricelistid && (parseInt(quantity)>=price.minqty && parseInt(quantity)<=price.maxqty));
      return price;
    },
    async insertPurchaseOrder() {
      if(this.transactions==null || this.transactions.length==0) return;
      let payload = {purchaseorder: this.new_purchaseorder, transactions: this.transactions};
      await this.insertPurchaseOrderRequest(payload);
      router.push('/purchaseorder/list');
    },
    insertTransaction(){
      if(!this.checkError2()) return;
      let find = this.transactions.find(trans=>trans.itemid==this.add_transaction.itemid);
      if(find==null) this.transactions.push(this.add_transaction);
      else this.updateTransaction();
      this.calculateTotal();
      this.clearFields();
    },
    populateItems(brandid){
      let items = this.items.filter(item=>item.brandid == brandid);
      this.branditems = items.map(x => {return {text: x.itemname, value: x._id};})
    },
    populatePriceField(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let qty = this.add_transaction.itemquantity!=null ? this.add_transaction.itemquantity : 1;
      let price = this.findPriceByQuantity(this.new_purchaseorder.pricelistid, item._id, qty);

      let new_trans = {
        itemimage: item.itemimage, 
        itemname: item.itemname,
        unit: price!=null ? price.unit : '', 
        itemcost: price!=null ? price.listprice : 0,
        itemquantity: qty
      };

      this.add_transaction = Object.assign({}, this.add_transaction, new_trans);
      this.calculateAmount();
    },
    populatePriceFieldEdit(itemid){
      let item = this.items.find(item=>item._id == itemid);
      let qty = this.edit_transaction.itemquantity!=null ? this.edit_transaction.itemquantity : 1;
      let price = this.findPriceByQuantity(this.new_purchaseorder.pricelistid, item._id, qty);

      let new_trans = {
        itemimage: item.itemimage, 
        itemname: item.itemname,
        unit: price!=null ? price.unit : '', 
        itemcost: price!=null ? price.listprice : 0,
        itemquantity: qty
      };

      this.edit_transaction = Object.assign({}, this.edit_transaction, new_trans);
      this.calculateAmount();
    },
    updateTransaction(){
      let index = this.transactions.findIndex((trans) => trans.itemid == this.add_transaction.itemid);
      this.transactions.splice(index, 1, this.add_transaction);
      this.calculateTotal();
      this.clearFields();
    },
    selectVendor(vendorid){
      let vendor = this.vendors.find(vendor=>vendor._id==vendorid);
      this.new_purchaseorder.purchaseordername = vendor.vendorname;
      this.new_purchaseorder.purchaseorderaddress = vendor.vendoraddress;
      this.new_purchaseorder.purchaseorderphone = vendor.vendorphone;
      this.new_purchaseorder.purchaseordermobile = vendor.vendormobile;
      this.new_purchaseorder.vendorid = vendor._id;
    },
  },

  async created () {
    
    if(this.brands.length==0) await this.getBrandsRequest();    
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
    if(this.prices.length==0) await this.getPricesRequest();
    if(this.pricelists.length==0) await this.getPriceListsRequest();
    if(this.vendors.length==0) await this.getVendorsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
